// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerifiedOutlinedSvg from "@fishx/icons-svg/es/asn/PVerifiedOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerifiedOutlined = function PVerifiedOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerifiedOutlinedSvg
  }));
};

PVerifiedOutlined.displayName = 'PVerifiedOutlined';
export default React.forwardRef(PVerifiedOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerifiedOutlined.js
// module id = 3713
// module chunks = 0